import React from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import Close from 'src/assets/images/CloseProduct.svg';
import UserIcon from 'src/assets/images/UserEmphasis.svg';
import { initiateProxy } from 'src/pages/more/pages/proxies/redux/action/index.js';
import { useHistory } from 'react-router-dom';
import {
    HeaderTextContainer1,
    HeaderTextContainer2,
    HeaderTextContainer3,
    UserContainer,
    UserContainer1,
    CloseIcon,
    Line,
    DesignationText,
    UserName,
    Container1,
    ContainerGrid1,
    TextBold,
    BottomNavigationButtonContainer,
} from './index.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { useViewportHeight } from 'src/utils/useViewportHeight';
import { sizes } from 'src/styles/Media.styled';
import { getPageVisibilityRule } from 'src/pages/home/redux/actions';
import { getImpersonationUserData } from 'src/pages/impersonation/redux/actions';
import { getBannerDetails, getConfigurations } from 'src/common/redux/actions';
import { MENU } from 'src/constants/appConstants';
import {
    saveAccountFilterStateForImpersonation,
    savePhysicianFilterStateForImpersonation,
    saveOrderFilterStateForImpersonation,
    clearDataOnNewImpersonate,
} from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const InitiateProxy = (props) => {
    const dispatch = useDispatch();
    const store = useStore();
    const history = useHistory();
    const { t } = useTranslation();
    const viewportHeight = useViewportHeight();
    // const [showHome, setshowHome] = useState(false);

    const initiateProxyStatus = useSelector(
        (state) => state.InitiateProxyReducer.statusCode
    );

    useEffectWithErrorLogging(() => {
        if (initiateProxyStatus === '200') {
            saveAccountFilterStateForImpersonation(store.getState());
            savePhysicianFilterStateForImpersonation(store.getState());
            saveOrderFilterStateForImpersonation(store.getState());
            clearDataOnNewImpersonate(dispatch);
            localStorage.setItem(
                'userBaseSiteId',
                localStorage.getItem('baseSiteId')
            );
            localStorage.setItem(
                'baseSiteId',
                props.proxyData.proxyEmployee.baseSiteId
            );
            sessionStorage.setItem(
                'impersonatedUserId',
                props.proxyData.user.networkId
            );
            props.onHide();
            history.push(
                `/?proxyFlag=true&proxyUser=${props.proxyData.user.networkId}`
            );
            dispatch(getImpersonationUserData());
            dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
            dispatch(getPageVisibilityRule({ fields: 'BASIC' }));
            dispatch(getBannerDetails());
        }
    }, [initiateProxyStatus]);

    const openHome = () => {
        dispatch(initiateProxy(props.proxyData));
        // setshowHome(true);
        // props.onHide();
    };

    const closeHome = () => {
        props.handleClose();
        // setshowHome(false);
    };

    return (
        <>
            <Container1
                container
                justifyContent={'space-between'}
                direction="row"
                alignItems="center"
            >
                <ContainerGrid1
                    item
                    xs={11}
                    sm={11}
                    md={11}
                    lg={11}
                    xl={11}
                    mobile={6}
                >
                    <HeaderTextContainer1>
                        {t('proxies.initiateproxy.heading')}
                    </HeaderTextContainer1>
                </ContainerGrid1>
                <ContainerGrid1
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={6}
                >
                    <CloseIcon
                        mobilePath={Close}
                        onClick={props.handleClose}
                        show={true}
                    />
                </ContainerGrid1>
            </Container1>
            <HeaderTextContainer2>
                {t('proxies.initiateproxy.subheading')}
            </HeaderTextContainer2>
            <UserContainer>
                <HeaderTextContainer3
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    mobile={6}
                >
                    {t('proxies.initiateproxy.user')}
                </HeaderTextContainer3>
                <span style={{ display: 'flex' }}>
                    <img
                        src={UserIcon}
                        style={{
                            marginLeft: '-2px',
                            marginTop: '-6px',
                        }}
                    />

                    <UserContainer1 style={{ paddingLeft: '10px' }}>
                        <UserName><span className="more-person-name-dt-mask">{props.proxyData.user.displayName}</span></UserName>
                        <DesignationText>
                            {props.proxyData.user.employeeRole}
                        </DesignationText>
                    </UserContainer1>
                </span>
            </UserContainer>
            <Line></Line>
            <BottomNavigationButtonContainer
                ipadPadding={'0px'}
                mbPadding={'0px 0px 0px 0px'}
                viewportHeight={viewportHeight}
            >
                <Button
                id={'proxies-initiateProxy-cancelButton'}
                    clearNotes
                    show={true}
                    // cancel={true}
                    variant={ButtonStyles?.cancel}
                    width={'102px'}
                    height={'38px'}
                    // fontSize={'15px'}
                    margin={'16px 10px 0px 4px'}
                    mobileMargin={'15px 5px 10px 15px'}
                    clicked={closeHome}
                >
                    <TextBold color={'#140F4B'}>
                        {t('proxies.initiateproxy.cancel')}
                    </TextBold>
                </Button>
                <Button
                id={'proxies-initiateProxy-startProxyingButton'}
                    show
                    // primary={true}
                    variant={ButtonStyles?.primary}
                    width={'140px'}
                    height={'38px'}
                    // fontSize={'15px'}
                    mobileMargin={'15px 1px 10px 10px'}
                    margin={
                        window.innerWidth == sizes.smalDevice
                            ? '16px 0px 0px 4px'
                            : '16px 4px 0px 4px'
                    }
                    clicked={openHome}
                >
                    <TextBold color={'#FFFF'}>
                        {t('proxies.initiateproxy.startproxying')}
                    </TextBold>
                </Button>
            </BottomNavigationButtonContainer>
        </>
    );
};
export default InitiateProxy;
